import React, { useState, useEffect } from "react";
import Select from "react-select";

// Utility Function to Get Unique ChemistInfo
const getUniqueChemistInfo = (data) => {
  const unique = [...new Set(data.map((item) => item.ChemistInfo))];
  return unique.map((item) => ({ value: item, label: item })); // Transform for react-select
};

const ChemistDropdown = ({ data, selectedChemist, setSelectedChemist, showLabel= true }) => {
  const [chemistOptions, setChemistOptions] = useState([]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "#ccc" : "#ddd",
      boxShadow: state.isFocused ? "0 0 0 2px #f0f0f0" : "none",
      "&:hover": {
        borderColor: "#bbb",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#f0f8ff"
        : state.isFocused
        ? "#e6f7ff"
        : "white",
      color: state.isSelected ? "#000" : "#333",
      "&:active": {
        backgroundColor: "#cce7ff",
      },
    }),
  };

  // Populate dropdown options with unique ChemistInfo
  useEffect(() => {
    const uniqueChemistInfo = getUniqueChemistInfo(data);
    setChemistOptions(uniqueChemistInfo);
  }, [data]);

  const handleSelectChange = (selectedOption) => {
    setSelectedChemist(selectedOption?.value || ""); // Update the selected chemist value
  };

  return (
    <div className="dropdownUI">
     {showLabel && <label htmlFor="chemist-dropdown" style={{ marginBottom: "8px", display: "block" }}>
        Select Chemist:
      </label>}
      <Select
        styles={customStyles}
        id="chemist-dropdown"
        value={chemistOptions.find((option) => option.value === selectedChemist) || null}
        onChange={handleSelectChange}
        options={chemistOptions}
        placeholder="-- Select Chemist --"
        isSearchable
        className="allProductsTable__searchBox searchable_dropdown__filter"
      />
    </div>
  );
};

export default ChemistDropdown;
